import { CaretRight, Vault } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

import { categoryMeta } from '../accounts/assetCategories';
import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { formatEUR } from '../../utils/money';

/** .pen `ds/row/composition-item` (instância "onde está guardado"). */
function StoredAccountRow({ icon: Icon, name, amount }) {
  return (
    <div className="flex items-center gap-space-2 border-t border-border py-space-3 first:border-t-0">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-sm bg-sage-tint text-sage-on-tint">
        <Icon className="h-4 w-4" aria-hidden />
      </span>
      <span className="type-display-row min-w-0 flex-1 font-medium text-foreground">
        {name}
      </span>
      <span className="type-display-row shrink-0 font-numeric font-semibold text-foreground">
        {formatEUR(amount)}
      </span>
    </div>
  );
}

/** .pen `ds/card/composition-group` (instância "onde está guardado"). */
export function EmergencyFundStoredSection({ accounts, totalSaved }) {
  const copy = pt.emergencyFund.dashboard.stored;

  if (!accounts?.length) return null;

  const editHref = `${paths.emergencyFundWizard}?step=expenses`;

  return (
    <div className="overflow-hidden rounded-ds-lg border border-border bg-card shadow-sm dark:shadow-none">
      <div className="flex items-center gap-space-3 px-space-5 py-space-4">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-ds-sm bg-sage-tint text-sage-on-tint">
          <Vault className="h-4 w-4" aria-hidden />
        </span>
        <span className="min-w-0 flex-1">
          <span className="type-title-card block text-foreground">{copy.title}</span>
          <span className="type-chip block font-normal text-muted-foreground">
            {copy.subtitle
              .replace('{count}', String(accounts.length))
              .replace('{total}', formatEUR(totalSaved))}
          </span>
        </span>
      </div>

      <div className="border-t border-border px-space-5 pb-space-4">
        {accounts.map((row) => {
          const Icon = categoryMeta(row.category).icon;
          const amount = Number(row.amountEur ?? row.amount ?? 0);
          return (
            <StoredAccountRow key={row.id ?? row.accountId} icon={Icon} name={row.name} amount={amount} />
          );
        })}

        <div className="mt-space-2 flex justify-center border-t border-border pt-space-2">
          <Link
            to={editHref}
            className="type-body-sm inline-flex items-center gap-space-1 font-semibold text-sage-on-tint hover:underline"
          >
            {copy.editCta}
            <CaretRight className="h-3.5 w-3.5" aria-hidden />
          </Link>
        </div>
      </div>
    </div>
  );
}

/** .pen `ds/banner/promo--sage` (instância "onde guardar este dinheiro"). */
export function EmergencyFundAdvancedPlanTeaser() {
  const copy = pt.emergencyFund.dashboard.advanced;

  return (
    <Link
      to={paths.emergencyFundPlano}
      className="flex items-center gap-space-3 rounded-ds-xl bg-sage-solid px-space-4 py-space-3 shadow-[0_6px_16px] shadow-sage-glow-soft transition hover:brightness-105"
    >
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-ds-md bg-on-hero-track text-sage-on-solid">
        <Vault className="h-5 w-5" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="type-chip mb-0.5 inline-block rounded-ds-sm bg-on-hero-track px-1.5 py-0.5 font-bold uppercase tracking-wide text-sage-on-solid">
          {copy.badge}
        </span>
        <span className="type-body block font-bold text-sage-on-solid">{copy.title}</span>
        <span className="type-chip block font-normal text-sage-on-solid-muted">{copy.subtitle}</span>
      </span>
    </Link>
  );
}

export default EmergencyFundStoredSection;
